export default __webpack_public_path__ + "static/media/hacker3.78235110.png";